/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Image } from 'react-native'
import styles from './Styles/BackButtonComponentStyle'
import {
  Container, Icon, Header,
  Content, ListItem,
  CheckBox, Thumbnail,
  Text, Left, Body, Right, Item, Input, Button
} from 'native-base';
import { SvgBackButton } from './SvgComponent';
export default class BackButtonComponent extends Component {


  render() {
    return (
      <Button style = {{marginLeft: 10}} transparent onPress = {this.props.onPress}><SvgBackButton /></Button>
    )
  }
}
